<template>
    <section>
        <img src="images/aranysav.jpg" width="100%" alt="">
        <!----------------------------------
        footer_top
        ------------------------------------>
        <section class="new_footer_top_area" style="background:#301e1c">
            <div class="container">
                <div class="row">
                    <div class="col-sm-5">
                        <div class="my_widget_conts">
                            <div class="my_widget_box">
                                <div class="my_widget">
                                    <img src="images/env.png" width="60" alt=""> <span style="margin-left:20px;font-size:16pt;">info@panoramabekescsaba.hu</span>
                                </div>
                            </div>
                            <div class="widget_below_box">
                                <div class="widget_form_box" style="margin: 0 80px 0 70px;">
                                    <div class="form-group">
                                        <input class="form-control footer-input" type="name" placeholder="Név" name="firstname" required="" v-model="name">
                                    </div>
                                    <div class="form-group">
                                        <input class="form-control footer-input" type="name" placeholder="Email" name="firstname" required="" v-model="email">
                                    </div>
                                    <div class="form-group">
                                        <textarea class="form-control footer-input" placeholder="Üzenet írása..." name="message" v-model="message"></textarea>
                                    </div>
                                    <div class="form-group">
                                        <button class="my-button"
                                        style="background-image: url('images/aranysav.jpg');"
                                         @click="sendEmail">Küldés</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="my_widget_conts">
                            <span style="font-size:28px; color:#F1EBC7;">TÉRKÉP</span>
                            <div class="widget_below_box">
                                <div class="map_box">
                                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2737.4696593279227!2d21.130413815598505!3d46.67673077913394!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47442b0c47278f7b%3A0xbfbd1c8b3f70f949!2sPanor%C3%A1ma+Hotel!5e0!3m2!1shu!2shu!4v1544196393394" width="200" height="130" frameborder="0" style="border:0" allowfullscreen></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="my_widget_conts">
                            <span style="font-size:28px; color:#F1EBC7;">KAPCSOLAT</span>
                            <div class="contact">
                                <img src="images/iphone.png" alt=""><span>+ 36 66 547-770</span><br>
                                <img src="images/imobile.png" alt=""><span>+ 36 30/ 278 35 32</span><br>
                                <a href="mailto:info@panoramabekescsaba.hu"><img src="images/iemail.png" alt=""><span>info@panoramabekescsaba.hu</span><br></a>
                                <img src="images/iplace.png" alt=""><span>5600 Békéscsaba, Gyulai út 84.</span><br>

                            </div>
                        </div>
                    </div>
                    <!-- <div class="col-sm-2">
                        <div class="up-div" style="float:right; margin-top:-30px;">
                            <a onclick="$('html, body').animate({ scrollTop: 0 }, 'slow');" style="color:white"><i class="fa fa-chevron-up fa-3x"></i></a>
                        </div>
                        <div class="widget_below_box">
                            <div class="widget_form_box text-center">
                                <div class="form-group">
                                    <input class="form-control" type="name" placeholder="Email" required="" v-model="emailNewsletter">
                                </div>
                                <div class="form-group">
                                    <input class="form-control" type="name" placeholder="Név" required="" v-model="nameNewsletter">
                                </div>
                                <div class="form-group">
                                    <button class="my-button" @click="subsribe">Feliratkozás a hírlevélre</button>
                                </div>
                            </div>
                        </div>
                    </div> -->

                </div>

            </div>
        </section>
        <!----------------------------------
         footer_top
         ------------------------------------>


        <footer class="new_last_footer" style="padding: 10px 0;">
            <div class="container">
                <div class="row">
                    <div class="new_copy_text text-center">
                        <p>Panoráma Wellness Kft. Copyright     -      Minden jog fenntartva.</p>
                    </div>
                </div>
            </div>
        </footer>
    </section>
</template>

<script>
import Endpoints from '@commons/communication/endpoints.js'

export default{
    mixins:[Endpoints],
    data:function () {
        return {
            name:'',
            email:'',
            message:'',
            emailNewsletter:'',
            nameNewsletter:'',
        };
    },
    methods:{
        sendEmail:function () {
            if (!this.email && !this.email || !this.message){
                toastr.warning('Minden adat kitöltése kötelező')
                return;
            }
            var self = this

            this.connSendBoraEmail(this.name,this.email,this.message,function (r) {

            })
            self.name = ''
            self.email = ''
            self.message = ''
            toastr.success('Üzenetedet fogadtuk, munkatársunk hamarosan felveszi veled a kapcsolatot.')
        },
        subsribe:function () {
            this.connSubscribeToNewsletter(this.emailNewsletter,this.nameNewsletter,function (r) {
                toastr.success('Sikeres feliratkozás');
            })
        }
    }
}


</script>


<style>

.my-button{
    background-size: contain;
    color:black;
    text-transform: uppercase;
    font-size: 14pt;
    border-radius: 0px;
    padding: 8px 16px;
    font-weight: bold;
    width: 100%;
    border-radius: 8px;
    border:none;
    outline:none;
}
.widget_form_box input{
    color:white;
}
.widget_form_box textarea{
    color:white;
}
.footer-input{
    border-radius: 8px;
    font-style: italic;
    color:#F0ECC7 !important;
    background: #3F2C28 !important;
    resize:none;
}
.contact{
    /* margin-right: -50px; */
    margin-top: 20px;
    color:#F0ECC7;
    font-size:18px;
}
.contact img{
    margin-right: 10px;
    height: 40px;
    margin-bottom: 15px;
}
.contact span{
    margin-bottom: 15px;
    color:#F0ECC7!important;
}
</style>



// WEBPACK FOOTER //
// Footer.vue?45beacf8